/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Inbound from './Inbound/index'
import No from './No/index'
import Outbound from './Outbound/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let smsIsInboundValueData = fromData.useDataFormat({ viewPath,
context: 'sms',
path: 'is_inbound',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: smsIsInboundValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Outbound'}>
<Outbound
  viewPath={`${viewPath}/Outbound`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Inbound'}>
<Inbound
  viewPath={`${viewPath}/Inbound`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}